import Mutations from '../../odata/mutations';

export default { ...new Mutations('batchPrintingVerification'), ...new Mutations('batchPrintingVerifications') };
